import React from "react";

const StyledMdText = ({ children, fontColor }) => {
  return (
    <p className={`text-md font-normal font-inter ${fontColor}`}>{children}</p>
  );
};

export default StyledMdText;
